import React from "react";

import { DetailItemInfoType } from "../types";

const ItemInfo: React.FC<DetailItemInfoType> = ({
  title,
  additionalInfo,
  transparentAccountInfo,
}) => {
  return (
    <div className="mb-4 break-words text-grey-160 sm:mx-6 sm:mb-0 sm:min-w-0">
      <div className="font-semibold text-grey-200" dangerouslySetInnerHTML={{ __html: title }}>
      </div>
      {transparentAccountInfo && <div className="mt-1 text-xs">{transparentAccountInfo}</div>}

      {additionalInfo && <div className="mt-1 text-xs">{additionalInfo}</div>}
    </div >
  );
};

export default ItemInfo;
